<script>

    import Rest from "../public/lib/rest";
    import moment from 'moment'

    let selectedType = 'ALL';

    let cars = [];
    let months = [];
    let rents = [];

    let totalDays = 0;
    let dayNumbers = [];

    let singleDayNumberWidth = 10;

    let monthData = [
        {
            name: "Styczeń",
            days: 31
        },
        {
            name: "Luty",
            days: 28
        },
        {
            name: "Marzec",
            days: 31
        },
        {
            name: "Kwiecień",
            days: 30
        },
        {
            name: "Maj",
            days: 31
        },
        {
            name: "Czerwiec",
            days: 30
        },
        {
            name: "Lipiec",
            days: 31
        },
        {
            name: "Sierpień",
            days: 31
        },
        {
            name: "Wrzesień",
            days: 30
        },
        {
            name: "Październik",
            days: 31
        },
        {
            name: "Listopad",
            days: 30
        },
        {
            name: "Grudzień",
            days: 31
        }
    ];

    export function setup(data) {
        cars = data.cars.sort(function (a, b) {
            return a.carType.localeCompare(b.carType);
        });

        let date = new Date();

        months = [{
            month: date.getMonth()
        }, {
            month: (date.getMonth() + 1) % 12
        }, {
            month: (date.getMonth() + 2) % 12
        }, {
            month: (date.getMonth() + 3) % 12
        }, {
            month: (date.getMonth() + 4) % 12
        }];

        let success = 0;
        Rest.getActualRents().then(function (response) {
            rents = jQuery.merge(rents, response.value);
            success++;
            if (success === 2) {
                calculateData();
            }
        });
        Rest.getFutureRents().then(function (response) {
            rents = jQuery.merge(rents, response.value);
            success++;
            if (success === 2) {
                calculateData();
            }
        });
    }

    function calculateData() {

        let month = new Date().getMonth();

        monthData[month].left = monthData[month].days - new Date().getDate() + 1;
        for (var i = new Date().getDate(); i <= monthData[month].days; i++) {
            dayNumbers.push(i);
        }
        monthData[(month + 1) % 12].left = monthData[(month + 1) % 12].days;
        for (var i = 1; i <= monthData[(month + 1) % 12].left; i++) {
            dayNumbers.push(i);
        }
        monthData[(month + 2) % 12].left = monthData[(month + 2) % 12].days;
        for (var i = 1; i <= monthData[(month + 2) % 12].left; i++) {
            dayNumbers.push(i);
        }
        monthData[(month + 3) % 12].left = monthData[(month + 3) % 12].days;
        for (var i = 1; i <= monthData[(month + 3) % 12].left; i++) {
            dayNumbers.push(i);
        }
        monthData[(month + 4) % 12].left = monthData[(month + 4) % 12].days;
        for (var i = 1; i <= monthData[(month + 4) % 12].left; i++) {
            dayNumbers.push(i);
        }
        dayNumbers = dayNumbers;

        totalDays = monthData[month].left + monthData[(month + 1) % 12].left + monthData[(month + 2) % 12].left + monthData[(month + 3) % 12].left + monthData[(month + 4) % 12].left;

        monthData = monthData;

        let dataWidth = jQuery("#header").width() - 250;

        singleDayNumberWidth = (dataWidth / totalDays).toFixed(0) - 1;
        singleDayNumberWidth = 30;

        dataWidth = singleDayNumberWidth * totalDays;
        setWidth(jQuery("#header"), 250 + dataWidth);
        setWidth(jQuery("#calendarTable"), 250 + dataWidth);
        setWidth(jQuery("#calendarMain"), 250 + dataWidth);

        monthData[month].px = monthData[month].left * singleDayNumberWidth;
        monthData[(month + 1) % 12].px = monthData[(month + 1) % 12].left * singleDayNumberWidth;
        monthData[(month + 2) % 12].px = monthData[(month + 2) % 12].left * singleDayNumberWidth;
        monthData[(month + 3) % 12].px = monthData[(month + 3) % 12].left * singleDayNumberWidth;
        monthData[(month + 4) % 12].px = monthData[(month + 4) % 12].left * singleDayNumberWidth;

        jQuery("#header").children().eq(1).css({"width": monthData[month].px + "px"});
        jQuery("#header").children().eq(1).css({"min-width": monthData[month].px + "px"});

        jQuery("#header").children().eq(2).css({"width": monthData[(month + 1) % 12].px + "px"});
        jQuery("#header").children().eq(2).css({"min-width": monthData[(month + 1) % 12].px + "px"});

        jQuery("#header").children().eq(3).css({"width": monthData[(month + 2) % 12].px + "px"});
        jQuery("#header").children().eq(3).css({"min-width": monthData[(month + 2) % 12].px + "px"});

        jQuery("#header").children().eq(4).css({"width": monthData[(month + 3) % 12].px + "px"});
        jQuery("#header").children().eq(4).css({"min-width": monthData[(month + 3) % 12].px + "px"});

        jQuery("#header").children().eq(5).css({"width": monthData[(month + 4) % 12].px + "px"});
        jQuery("#header").children().eq(5).css({"min-width": monthData[(month + 4) % 12].px + "px"});

        let finishCalendarDate = moment().add(5, 'months').date(1).hour(0);
        rents.forEach(rent => {

            rent.startDateLong = rent.startDateLong / 1000;
            rent.endDateLong = rent.endDateLong / 1000;

            console.log(moment.unix(rent.startDateLong / 1000).format('DD-MM-YYYY'));

            if (moment.unix(rent.startDateLong).isBefore(moment())) {
                rent.startDateLong = moment().hour(0).minute(0).unix()
            }

            if (moment.unix(rent.endDateLong).isAfter(finishCalendarDate)) {
                rent.endDateLong = finishCalendarDate.unix()
            }

            let diffDays = 266 + moment.unix(rent.startDateLong).diff(moment().hour(0).minute(0), 'minutes') * dataWidth / (totalDays * 60 * 24);
            let widthDays = moment.unix(rent.endDateLong).diff(moment.unix(rent.startDateLong), 'minutes') * dataWidth / (totalDays * 60 * 24);

            jQuery("#" + rent.car.registrationNumber).children().eq(1).height(jQuery("#" + rent.car.registrationNumber).height());

            let tooltipText = rent.client.name1 + " " + rent.client.name2 + " <br/> " + rent.startDate + " <br/> " + rent.endDate;
            jQuery("#" + rent.car.registrationNumber).children().eq(1).append(jQuery(
                "<div data-html=\"true\"  data-toggle=\"tooltip\" data-placement=\"top\" title=\"" + tooltipText + "\" id='" + rent.uuid + "' style='left: " + diffDays.toFixed(0) + "px; width:" + widthDays.toFixed(0) + "px; '></div>"));
        });

        jQuery('[data-toggle="tooltip"]').tooltip();

        //console.log(rents)
        // setTimeout(function () {
        // }, 100);
    }

    function setWidth(elem, px) {
        elem.css({"width": px + "px"});
        elem.css({"min-width": px + "px"});
        elem.css({"max-width": px + "px"});
    }

    let leaderLine = null;

    function mouseOver(i) {
        mouseOut(i);
        leaderLine = new LeaderLine(
            document.getElementById('upper' + i),
            document.getElementById('lower' + i),
            {dash: {animation: true}, size: singleDayNumberWidth, color: 'red', startPlug: 'behind', endPlug: 'behind'}
        );
    }

    function mouseOut(i) {
        if (leaderLine) {
            leaderLine.hide();
            leaderLine = null;
        }
    }

    function updateCarType() {
        //calculateData();
    }
</script>

<div class="row">
    <div class="col-12 mt-4">
        <main class="chart-container mt-4" id="calendarMain">
            <main class="chart-container menuButtonsContainer">
                <span>Rodzaj auta</span><br/>
                <select bind:value={selectedType} on:change={updateCarType} style="color: black">
                    <option value="ALL">
                        Wszystkie
                    </option>
                    <option value="CAR_5">
                        5 osob
                    </option>
                    <option value="BUS_9">
                        9 osob
                    </option>
                    <option value="LARGE_TRUCK">
                        Dostawczak
                    </option>
                    <option value="TOW_TRUCK">
                        Laweta
                    </option>
                </select>
            </main>

            <table class="table table-dark noMarginBottom" id="calendarTable" style="border-right: 1px solid #95999c;">
                <thead>
                <tr id="header">
                    <th class="d-none d-sm-table-cell" style="min-width: 250px;max-width: 250px;">Auto</th>
                    {#each months as m}
                        <th class="monthsRow" colspan="{monthData[m.month].left}">{monthData[m.month].name}</th>
                    {/each}
                </tr>
                </thead>
                <tbody class="calendartbody">
                <tr>
                    <td style="min-width: 250px;max-width: 250px; width:250px;"></td>
                    {#if dayNumbers}
                        {#each dayNumbers as d, i}
                            <td class="daysRow"
                                style="padding:0px; width:{singleDayNumberWidth}px; max-width:{singleDayNumberWidth}px; min-width:{singleDayNumberWidth}px;"
                                id="upper{i}"
                                on:mouseover={() => mouseOver(i)} on:mouseout={() => mouseOut(i)}>{d}</td>
                        {/each}
                    {/if}
                </tr>
                {#each cars as car}
                    <tr id="{car.registrationNumber}"
                        class:hidden={selectedType != 'ALL' && car.carType !== selectedType}>
                        <td class="d-none d-sm-table-cell"
                            style="min-width: 250px;max-width: 250px;">{car.name} {car.registrationNumber}</td>
                        <td class="calendartd" colspan="{totalDays}"></td>
                    </tr>
                {/each}
                <tr>
                    <td style="min-width: 250px;max-width: 250px; width:250px;"></td>
                    {#if dayNumbers}
                        {#each dayNumbers as d, i}
                            <td class="daysRow"
                                style="padding:0px; width:{singleDayNumberWidth}px; max-width:{singleDayNumberWidth}px; min-width:{singleDayNumberWidth}px;"
                                id="lower{i}"
                                on:mouseover={() => mouseOver(i)} on:mouseout={() => mouseOut(i)}
                            >{d}</td>
                        {/each}
                    {/if}
                </tr>
                </tbody>
            </table>
        </main>
    </div>
</div>
